import { render, staticRenderFns } from "./VsDropdownMenu.vue?vue&type=template&id=36340466&lang=html"
import script from "./VsDropdownMenu.vue?vue&type=script&lang=js"
export * from "./VsDropdownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports